import { route, type PageTour } from '../pageTour';
import { alertBoardSteps } from './alertBoardSteps';

export const alertBoardTour: PageTour = {
  id: 'page-alert-board',
  version: 2,
  title: 'Alert Board',
  summary: 'This site\'s live alerts as tiles, a GIS view or a map.',
  match: route('/alert-board', '/alert-board/gis', '/alert-board/map'),
  steps: alertBoardSteps(false),
};
